(function () {
  'use strict';

  var STRINGS = {
    en: {
      lang_label: 'Language',
      step1_title: 'What can we help you with?',
      type_cancel: 'Cancel Order',
      type_return: 'Return Item',
      type_damaged: 'Damaged / Defective',
      type_delivery: 'Delivery Issue',
      type_other: 'Other',
      btn_next: 'Next',
      btn_back: 'Back',
      btn_submit: 'Submit Enquiry',
      btn_start_over: 'Start over',
      yes: 'Yes',
      no: 'No',
      q_cancel_dispatched: 'Has your order been dispatched?',
      msg_cancel_no: 'Your cancellation will be processed and refund issued to your original payment method within 14 days.',
      msg_cancel_yes: 'Your order is already in transit. You may refuse delivery (return shipping costs will be deducted from your refund) or accept delivery and return the parcel unopened within 14 days at your own cost. The package must not be opened or altered.',
      ack_cancel_yes: 'I understand and accept these terms',
      q_return_date: 'When did you receive the item?',
      msg_return_expired: "Unfortunately, we're unable to process this return. The 14-day return window has passed and we cannot accept returns after this period.",
      q_return_worn: 'Has the item been worn or used?',
      msg_return_worn: "We're unable to accept returns of used items. All returned items must be unused with original tags attached.",
      q_return_packaging: 'Is the original packaging intact?',
      msg_return_packaging: "Unfortunately, we're unable to process this return. Items must be returned in their original packaging, and we cannot accept this return without it.",
      q_return_hygiene: 'Is this a hygiene-sealed product that has been opened?',
      msg_return_hygiene: "We're unable to accept returns of hygiene-sealed products once they have been opened.",
      msg_return_approved: 'Your return is approved. Post the item back to us using a tracked service at your own expense. Your refund will be issued within 14 days of us receiving and inspecting the item. Only standard delivery costs are refunded, not premium shipping.',
      q_return_intl: 'Are you based outside the UK?',
      msg_return_intl_note: 'A flat processing fee will be deducted from your refund for international returns.',
      q_delivery_what: 'What happened?',
      delivery_not_arrived: 'Order not arrived',
      delivery_wrong_item: 'Wrong item received',
      delivery_partial: 'Partial delivery',
      msg_delivery_not_arrived: "If your order hasn't arrived within the estimated delivery window, please provide your details below and we'll investigate. Please note that delivery timeframes are estimates — delays may occur due to unforeseen factors.",
      msg_delivery_wrong_item: "We're sorry you've received the wrong item. Please provide your order details below including which item you received and which item you ordered. We'll arrange a resolution as quickly as possible.",
      msg_delivery_partial: "If your order arrived incomplete, please provide your details below including which items are missing. We'll look into this and get back to you.",
      final_title: 'Your details',
      final_order_number: 'Order number',
      final_full_name: 'Full name',
      final_email: 'Email address',
      final_address: 'Delivery address',
      final_items: 'Item(s) affected',
      final_description: 'Description of enquiry',
      final_description_hint: '(minimum 20 characters)',
      final_photo: 'Photo upload',
      required_suffix: '(required)',
      optional_suffix: '(optional)',
      err_required: 'Please complete all required fields.',
      err_email: 'Please enter a valid email address.',
      err_min_chars: 'Please enter at least 20 characters in the description.',
      err_photo_required: 'Please attach at least one photo for this enquiry type.',
      success_title: 'Your enquiry is ready to send.',
      success_body: "Your email app will now open with your enquiry pre-filled. Please review it and, if you selected photos, attach them manually before sending — automatic attachment is not supported."
    },
    fr: {
      lang_label: 'Langue',
      step1_title: 'Comment pouvons-nous vous aider ?',
      type_cancel: 'Annuler la commande',
      type_return: 'Retourner un article',
      type_damaged: 'Endommagé / Défectueux',
      type_delivery: 'Problème de livraison',
      type_other: 'Autre',
      btn_next: 'Suivant',
      btn_back: 'Retour',
      btn_submit: 'Envoyer la demande',
      btn_start_over: 'Recommencer',
      yes: 'Oui',
      no: 'Non',
      q_cancel_dispatched: 'Votre commande a-t-elle été expédiée ?',
      msg_cancel_no: "Votre annulation sera traitée et le remboursement effectué sur votre moyen de paiement d'origine sous 14 jours.",
      msg_cancel_yes: "Votre commande est déjà en transit. Vous pouvez refuser la livraison (les frais de retour seront déduits de votre remboursement) ou accepter la livraison et retourner le colis non ouvert dans les 14 jours à vos frais. Le colis ne doit pas être ouvert ni modifié.",
      ack_cancel_yes: "Je comprends et j'accepte ces conditions",
      q_return_date: 'Quand avez-vous reçu l’article ?',
      msg_return_expired: "Nous ne sommes malheureusement pas en mesure de traiter ce retour. Le délai de retour de 14 jours est dépassé et nous ne pouvons pas accepter de retour après cette période.",
      q_return_worn: "L'article a-t-il été porté ou utilisé ?",
      msg_return_worn: "Nous ne pouvons pas accepter les retours d'articles utilisés. Tout article retourné doit être non utilisé, avec ses étiquettes d'origine.",
      q_return_packaging: "L'emballage d'origine est-il intact ?",
      msg_return_packaging: "Nous ne sommes malheureusement pas en mesure de traiter ce retour. Les articles doivent être retournés dans leur emballage d'origine, et nous ne pouvons pas accepter ce retour sans celui-ci.",
      q_return_hygiene: "S'agit-il d'un produit scellé pour raisons d'hygiène qui a été ouvert ?",
      msg_return_hygiene: "Nous ne pouvons pas accepter les retours de produits scellés pour raisons d'hygiène une fois qu'ils ont été ouverts.",
      msg_return_approved: "Votre retour est approuvé. Renvoyez-nous l'article via un service de livraison suivi, à vos frais. Votre remboursement sera émis dans les 14 jours suivant la réception et l'inspection de l'article. Seuls les frais de livraison standard sont remboursés, pas les frais d'expédition premium.",
      q_return_intl: 'Résidez-vous en dehors du Royaume-Uni ?',
      msg_return_intl_note: 'Des frais de traitement forfaitaires seront déduits de votre remboursement pour les retours internationaux.',
      q_delivery_what: "Que s'est-il passé ?",
      delivery_not_arrived: 'Commande non reçue',
      delivery_wrong_item: 'Article incorrect reçu',
      delivery_partial: 'Livraison partielle',
      msg_delivery_not_arrived: "Si votre commande n'est pas arrivée dans le délai de livraison estimé, veuillez indiquer vos coordonnées ci-dessous afin que nous puissions enquêter. Veuillez noter que les délais de livraison sont des estimations — des retards peuvent survenir en raison de facteurs imprévus.",
      msg_delivery_wrong_item: "Nous sommes désolés que vous ayez reçu le mauvais article. Veuillez indiquer ci-dessous les détails de votre commande, y compris l'article reçu et l'article commandé. Nous organiserons une solution dans les plus brefs délais.",
      msg_delivery_partial: "Si votre commande est arrivée incomplète, veuillez indiquer vos coordonnées ci-dessous, y compris les articles manquants. Nous étudierons la situation et reviendrons vers vous.",
      final_title: 'Vos coordonnées',
      final_order_number: 'Numéro de commande',
      final_full_name: 'Nom complet',
      final_email: 'Adresse e-mail',
      final_address: 'Adresse de livraison',
      final_items: 'Article(s) concerné(s)',
      final_description: 'Description de la demande',
      final_description_hint: '(minimum 20 caractères)',
      final_photo: 'Photo',
      required_suffix: '(obligatoire)',
      optional_suffix: '(facultatif)',
      err_required: 'Veuillez remplir tous les champs obligatoires.',
      err_email: 'Veuillez saisir une adresse e-mail valide.',
      err_min_chars: 'Veuillez saisir au moins 20 caractères dans la description.',
      err_photo_required: 'Veuillez joindre au moins une photo pour ce type de demande.',
      success_title: 'Votre demande est prête à être envoyée.',
      success_body: "Votre application e-mail va maintenant s'ouvrir avec votre demande pré-remplie. Merci de la vérifier et, si vous avez sélectionné des photos, de les joindre manuellement avant l'envoi — la pièce jointe automatique n'est pas prise en charge."
    },
    de: {
      lang_label: 'Sprache',
      step1_title: 'Wobei können wir Ihnen helfen?',
      type_cancel: 'Bestellung stornieren',
      type_return: 'Artikel zurücksenden',
      type_damaged: 'Beschädigt / Defekt',
      type_delivery: 'Lieferproblem',
      type_other: 'Sonstiges',
      btn_next: 'Weiter',
      btn_back: 'Zurück',
      btn_submit: 'Anfrage senden',
      btn_start_over: 'Von vorne beginnen',
      yes: 'Ja',
      no: 'Nein',
      q_cancel_dispatched: 'Wurde Ihre Bestellung bereits versandt?',
      msg_cancel_no: 'Ihre Stornierung wird bearbeitet und die Rückerstattung erfolgt innerhalb von 14 Tagen auf Ihre ursprüngliche Zahlungsmethode.',
      msg_cancel_yes: 'Ihre Bestellung ist bereits unterwegs. Sie können die Annahme verweigern (die Rücksendekosten werden von Ihrer Rückerstattung abgezogen) oder die Lieferung annehmen und das ungeöffnete Paket innerhalb von 14 Tagen auf eigene Kosten zurücksenden. Das Paket darf nicht geöffnet oder verändert werden.',
      ack_cancel_yes: 'Ich verstehe und akzeptiere diese Bedingungen',
      q_return_date: 'Wann haben Sie den Artikel erhalten?',
      msg_return_expired: 'Leider können wir diese Rücksendung nicht bearbeiten. Die 14-tägige Rückgabefrist ist abgelaufen, und wir können Rücksendungen nach Ablauf dieser Frist nicht mehr annehmen.',
      q_return_worn: 'Wurde der Artikel getragen oder benutzt?',
      msg_return_worn: 'Wir können keine Rücksendungen benutzter Artikel annehmen. Alle zurückgesendeten Artikel müssen unbenutzt sein und die Originaletiketten tragen.',
      q_return_packaging: 'Ist die Originalverpackung unversehrt?',
      msg_return_packaging: 'Leider können wir diese Rücksendung nicht bearbeiten. Artikel müssen in der Originalverpackung zurückgesendet werden, und wir können diese Rücksendung ohne sie nicht annehmen.',
      q_return_hygiene: 'Handelt es sich um ein hygieneversiegeltes Produkt, das geöffnet wurde?',
      msg_return_hygiene: 'Wir können keine Rücksendungen hygieneversiegelter Produkte annehmen, sobald diese geöffnet wurden.',
      msg_return_approved: 'Ihre Rücksendung wurde genehmigt. Senden Sie den Artikel per Sendungsverfolgung auf eigene Kosten an uns zurück. Ihre Rückerstattung erfolgt innerhalb von 14 Tagen nach Erhalt und Prüfung des Artikels. Es werden nur die Standardversandkosten erstattet, keine Premium-Versandkosten.',
      q_return_intl: 'Befinden Sie sich außerhalb des Vereinigten Königreichs?',
      msg_return_intl_note: 'Bei internationalen Rücksendungen wird eine pauschale Bearbeitungsgebühr von Ihrer Rückerstattung abgezogen.',
      q_delivery_what: 'Was ist passiert?',
      delivery_not_arrived: 'Bestellung nicht angekommen',
      delivery_wrong_item: 'Falscher Artikel erhalten',
      delivery_partial: 'Teillieferung',
      msg_delivery_not_arrived: 'Wenn Ihre Bestellung nicht innerhalb des geschätzten Lieferzeitraums angekommen ist, geben Sie bitte unten Ihre Daten an, damit wir dies prüfen können. Bitte beachten Sie, dass Lieferzeiten Schätzungen sind — Verzögerungen können aufgrund unvorhergesehener Umstände auftreten.',
      msg_delivery_wrong_item: 'Es tut uns leid, dass Sie den falschen Artikel erhalten haben. Bitte geben Sie unten Ihre Bestelldetails an, einschließlich des erhaltenen und des bestellten Artikels. Wir kümmern uns so schnell wie möglich um eine Lösung.',
      msg_delivery_partial: 'Wenn Ihre Bestellung unvollständig angekommen ist, geben Sie bitte unten Ihre Daten an, einschließlich der fehlenden Artikel. Wir werden dies prüfen und uns bei Ihnen melden.',
      final_title: 'Ihre Angaben',
      final_order_number: 'Bestellnummer',
      final_full_name: 'Vollständiger Name',
      final_email: 'E-Mail-Adresse',
      final_address: 'Lieferadresse',
      final_items: 'Betroffene(r) Artikel',
      final_description: 'Beschreibung der Anfrage',
      final_description_hint: '(mindestens 20 Zeichen)',
      final_photo: 'Foto-Upload',
      required_suffix: '(erforderlich)',
      optional_suffix: '(optional)',
      err_required: 'Bitte füllen Sie alle Pflichtfelder aus.',
      err_email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
      err_min_chars: 'Bitte geben Sie mindestens 20 Zeichen in der Beschreibung ein.',
      err_photo_required: 'Bitte fügen Sie mindestens ein Foto für diese Anfrageart bei.',
      success_title: 'Ihre Anfrage ist bereit zum Versenden.',
      success_body: 'Ihr E-Mail-Programm öffnet sich nun mit Ihrer vorausgefüllten Anfrage. Bitte prüfen Sie diese und fügen Sie ausgewählte Fotos manuell hinzu, bevor Sie sie senden — ein automatischer Anhang wird nicht unterstützt.'
    },
    it: {
      lang_label: 'Lingua',
      step1_title: 'Come possiamo aiutarti?',
      type_cancel: 'Annulla ordine',
      type_return: 'Restituisci articolo',
      type_damaged: 'Danneggiato / Difettoso',
      type_delivery: 'Problema di consegna',
      type_other: 'Altro',
      btn_next: 'Avanti',
      btn_back: 'Indietro',
      btn_submit: 'Invia richiesta',
      btn_start_over: 'Ricomincia',
      yes: 'Sì',
      no: 'No',
      q_cancel_dispatched: 'È già stato spedito il tuo ordine?',
      msg_cancel_no: 'La tua cancellazione verrà elaborata e il rimborso verrà emesso sul metodo di pagamento originale entro 14 giorni.',
      msg_cancel_yes: 'Il tuo ordine è già in transito. Puoi rifiutare la consegna (le spese di reso verranno detratte dal rimborso) oppure accettare la consegna e restituire il pacco non aperto entro 14 giorni a tue spese. Il pacco non deve essere aperto né alterato.',
      ack_cancel_yes: 'Comprendo e accetto questi termini',
      q_return_date: 'Quando hai ricevuto l’articolo?',
      msg_return_expired: 'Siamo spiacenti, non possiamo elaborare questo reso. La finestra di reso di 14 giorni è scaduta e non possiamo accettare resi dopo questo periodo.',
      q_return_worn: 'È stato indossato o utilizzato l’articolo?',
      msg_return_worn: 'Non possiamo accettare resi di articoli utilizzati. Tutti gli articoli restituiti devono essere non utilizzati, con le etichette originali.',
      q_return_packaging: 'È intatto l’imballaggio originale?',
      msg_return_packaging: "Siamo spiacenti, non possiamo elaborare questo reso. Gli articoli devono essere restituiti nell'imballaggio originale e non possiamo accettare questo reso senza di esso.",
      q_return_hygiene: 'Si tratta di un prodotto sigillato per igiene che è stato aperto?',
      msg_return_hygiene: 'Non possiamo accettare resi di prodotti sigillati per igiene una volta aperti.',
      msg_return_approved: 'Il tuo reso è approvato. Rispediscici l’articolo tramite un servizio tracciato a tue spese. Il rimborso sarà emesso entro 14 giorni dal ricevimento e dall’ispezione dell’articolo. Vengono rimborsate solo le spese di spedizione standard, non quelle premium.',
      q_return_intl: 'Ti trovi al di fuori del Regno Unito?',
      msg_return_intl_note: 'Per i resi internazionali verrà detratta dal rimborso una commissione di gestione forfettaria.',
      q_delivery_what: 'È successo cosa?',
      delivery_not_arrived: 'Ordine non arrivato',
      delivery_wrong_item: 'Articolo sbagliato ricevuto',
      delivery_partial: 'Consegna parziale',
      msg_delivery_not_arrived: 'Se il tuo ordine non è arrivato entro la finestra di consegna stimata, fornisci i tuoi dati qui sotto e indagheremo. Ti ricordiamo che i tempi di consegna sono stime — possono verificarsi ritardi dovuti a fattori imprevisti.',
      msg_delivery_wrong_item: "Siamo spiacenti che tu abbia ricevuto l'articolo sbagliato. Fornisci qui sotto i dettagli del tuo ordine, incluso l'articolo ricevuto e quello ordinato. Organizzeremo una soluzione il prima possibile.",
      msg_delivery_partial: 'Se il tuo ordine è arrivato incompleto, fornisci qui sotto i tuoi dati, inclusi gli articoli mancanti. Verificheremo la situazione e ti ricontatteremo.',
      final_title: 'I tuoi dati',
      final_order_number: "Numero d'ordine",
      final_full_name: 'Nome completo',
      final_email: 'Indirizzo email',
      final_address: 'Indirizzo di consegna',
      final_items: 'Articolo/i interessato/i',
      final_description: 'Descrizione della richiesta',
      final_description_hint: '(minimo 20 caratteri)',
      final_photo: 'Caricamento foto',
      required_suffix: '(obbligatorio)',
      optional_suffix: '(facoltativo)',
      err_required: 'Compila tutti i campi obbligatori.',
      err_email: 'Inserisci un indirizzo email valido.',
      err_min_chars: 'Inserisci almeno 20 caratteri nella descrizione.',
      err_photo_required: 'Allega almeno una foto per questo tipo di richiesta.',
      success_title: 'La tua richiesta è pronta per l’invio.',
      success_body: "Si aprirà ora la tua app di posta con la richiesta precompilata. Verificala e, se hai selezionato delle foto, allegale manualmente prima di inviarla — l'allegato automatico non è supportato."
    },
    es: {
      lang_label: 'Idioma',
      step1_title: '¿En qué podemos ayudarte?',
      type_cancel: 'Cancelar pedido',
      type_return: 'Devolver artículo',
      type_damaged: 'Dañado / Defectuoso',
      type_delivery: 'Problema de entrega',
      type_other: 'Otro',
      btn_next: 'Siguiente',
      btn_back: 'Atrás',
      btn_submit: 'Enviar consulta',
      btn_start_over: 'Empezar de nuevo',
      yes: 'Sí',
      no: 'No',
      q_cancel_dispatched: '¿Su pedido ya ha sido enviado?',
      msg_cancel_no: 'Su cancelación se procesará y el reembolso se emitirá a su método de pago original en un plazo de 14 días.',
      msg_cancel_yes: 'Su pedido ya está en tránsito. Puede rechazar la entrega (los costes de devolución se deducirán de su reembolso) o aceptar la entrega y devolver el paquete sin abrir en un plazo de 14 días, corriendo con los gastos. El paquete no debe abrirse ni alterarse.',
      ack_cancel_yes: 'Entiendo y acepto estos términos',
      q_return_date: '¿Cuándo recibió el artículo?',
      msg_return_expired: 'Lo sentimos, no podemos procesar esta devolución. El plazo de devolución de 14 días ha vencido y no podemos aceptar devoluciones después de este período.',
      q_return_worn: '¿Se ha usado o llevado puesto el artículo?',
      msg_return_worn: 'No podemos aceptar devoluciones de artículos usados. Todos los artículos devueltos deben estar sin usar, con las etiquetas originales.',
      q_return_packaging: '¿El embalaje original está intacto?',
      msg_return_packaging: 'Lo sentimos, no podemos procesar esta devolución. Los artículos deben devolverse en su embalaje original, y no podemos aceptar esta devolución sin él.',
      q_return_hygiene: '¿Es este un producto con precinto de higiene que ha sido abierto?',
      msg_return_hygiene: 'No podemos aceptar devoluciones de productos con precinto de higiene una vez abiertos.',
      msg_return_approved: 'Su devolución ha sido aprobada. Envínos el artículo mediante un servicio con seguimiento, corriendo con los gastos. Su reembolso se emitirá en un plazo de 14 días tras recibir e inspeccionar el artículo. Solo se reembolsan los gastos de envío estándar, no los de envío premium.',
      q_return_intl: '¿Se encuentra fuera del Reino Unido?',
      msg_return_intl_note: 'Se deducirá una tarifa fija de gestión de su reembolso para las devoluciones internacionales.',
      q_delivery_what: '¿Qué ha ocurrido?',
      delivery_not_arrived: 'Pedido no recibido',
      delivery_wrong_item: 'Artículo incorrecto recibido',
      delivery_partial: 'Entrega parcial',
      msg_delivery_not_arrived: 'Si su pedido no ha llegado dentro del plazo de entrega estimado, indique sus datos a continuación para que podamos investigarlo. Tenga en cuenta que los plazos de entrega son estimaciones — pueden producirse retrasos debido a factores imprevistos.',
      msg_delivery_wrong_item: 'Lamentamos que haya recibido el artículo equivocado. Indique a continuación los detalles de su pedido, incluyendo el artículo recibido y el artículo solicitado. Organizaremos una solución lo antes posible.',
      msg_delivery_partial: 'Si su pedido llegó incompleto, indique sus datos a continuación, incluyendo los artículos que faltan. Revisaremos la situación y nos pondremos en contacto con usted.',
      final_title: 'Sus datos',
      final_order_number: 'Número de pedido',
      final_full_name: 'Nombre completo',
      final_email: 'Dirección de correo electrónico',
      final_address: 'Dirección de entrega',
      final_items: 'Artículo(s) afectado(s)',
      final_description: 'Descripción de la consulta',
      final_description_hint: '(mínimo 20 caracteres)',
      final_photo: 'Subida de foto',
      required_suffix: '(obligatorio)',
      optional_suffix: '(opcional)',
      err_required: 'Complete todos los campos obligatorios.',
      err_email: 'Introduzca una dirección de correo electrónico válida.',
      err_min_chars: 'Introduzca al menos 20 caracteres en la descripción.',
      err_photo_required: 'Adjunte al menos una foto para este tipo de consulta.',
      success_title: 'Su consulta está lista para enviarse.',
      success_body: 'Su aplicación de correo se abrirá ahora con la consulta precompletada. Revísela y, si seleccionó fotos, adjúntelas manualmente antes de enviarla — el adjunto automático no es compatible.'
    },
    pl: {
      lang_label: 'Język',
      step1_title: 'W czym możemy pomóc?',
      type_cancel: 'Anuluj zamówienie',
      type_return: 'Zwróć produkt',
      type_damaged: 'Uszkodzony / Wadliwy',
      type_delivery: 'Problem z dostawą',
      type_other: 'Inne',
      btn_next: 'Dalej',
      btn_back: 'Wstecz',
      btn_submit: 'Wyślij zgłoszenie',
      btn_start_over: 'Zacznij od nowa',
      yes: 'Tak',
      no: 'Nie',
      q_cancel_dispatched: 'Czy Twoje zamówienie zostało już wysłane?',
      msg_cancel_no: 'Twoja anulacja zostanie przetworzona, a zwrot środków zostanie zrealizowany na Twoją pierwotną metodę płatności w ciągu 14 dni.',
      msg_cancel_yes: 'Twoje zamówienie jest już w drodze. Możesz odmówić przyjęcia przesyłki (koszty zwrotu zostaną potrącone z Twojego zwrotu) lub przyjąć przesyłkę i zwrócić nieotwartą paczkę w ciągu 14 dni na własny koszt. Paczka nie może zostać otwarta ani naruszona.',
      ack_cancel_yes: 'Rozumiem i akceptuję te warunki',
      q_return_date: 'Kiedy otrzymałeś/aś produkt?',
      msg_return_expired: 'Niestety nie możemy przetworzyć tego zwrotu. 14-dniowy okres na zwrot minął i nie możemy przyjąć zwrotu po tym okresie.',
      q_return_worn: 'Czy produkt był noszony lub używany?',
      msg_return_worn: 'Nie możemy przyjmować zwrotów używanych produktów. Wszystkie zwracane produkty muszą być nieużywane, z oryginalnymi metkami.',
      q_return_packaging: 'Czy oryginalne opakowanie jest nienaruszone?',
      msg_return_packaging: 'Niestety nie możemy przetworzyć tego zwrotu. Produkty muszą być zwracane w oryginalnym opakowaniu, a bez niego nie możemy przyjąć tego zwrotu.',
      q_return_hygiene: 'Czy jest to produkt zapieczętowany ze względów higienicznych, który został otwarty?',
      msg_return_hygiene: 'Nie możemy przyjmować zwrotów produktów zapieczętowanych ze względów higienicznych po ich otwarciu.',
      msg_return_approved: 'Twój zwrot został zatwierdzony. Odeślij produkt do nas przesyłką z numerem śledzenia, na własny koszt. Zwrot środków zostanie zrealizowany w ciągu 14 dni od otrzymania i sprawdzenia produktu. Zwracane są wyłącznie standardowe koszty dostawy, a nie koszty przesyłki priorytetowej.',
      q_return_intl: 'Czy mieszkasz poza Wielką Brytanią?',
      msg_return_intl_note: 'W przypadku zwrotów międzynarodowych od zwrotu środków zostanie potrącona stała opłata manipulacyjna.',
      q_delivery_what: 'Co się stało?',
      delivery_not_arrived: 'Zamówienie nie dotarło',
      delivery_wrong_item: 'Otrzymano niewłaściwy produkt',
      delivery_partial: 'Częściowa dostawa',
      msg_delivery_not_arrived: 'Jeśli Twoje zamówienie nie dotarło w szacowanym terminie dostawy, podaj poniżej swoje dane, a my to sprawdzimy. Pamiętaj, że terminy dostawy są szacunkowe — mogą wystąpić opóźnienia z powodu nieprzewidzianych czynników.',
      msg_delivery_wrong_item: 'Przepraszamy, że otrzymałeś/aś niewłaściwy produkt. Podaj poniżej szczegóły zamówienia, w tym otrzymany produkt oraz zamówiony produkt. Jak najszybciej zorganizujemy rozwiązanie.',
      msg_delivery_partial: 'Jeśli Twoje zamówienie dotarło niekompletne, podaj poniżej swoje dane, w tym brakujące produkty. Sprawdzimy sprawę i skontaktujemy się z Tobą.',
      final_title: 'Twoje dane',
      final_order_number: 'Numer zamówienia',
      final_full_name: 'Imię i nazwisko',
      final_email: 'Adres e-mail',
      final_address: 'Adres dostawy',
      final_items: 'Dotyczący(e) produkt(y)',
      final_description: 'Opis zgłoszenia',
      final_description_hint: '(minimum 20 znaków)',
      final_photo: 'Przesyłanie zdjęcia',
      required_suffix: '(wymagane)',
      optional_suffix: '(opcjonalne)',
      err_required: 'Wypełnij wszystkie wymagane pola.',
      err_email: 'Podaj prawidłowy adres e-mail.',
      err_min_chars: 'Wpisz co najmniej 20 znaków w opisie.',
      err_photo_required: 'Załącz co najmniej jedno zdjęcie dla tego typu zgłoszenia.',
      success_title: 'Twoje zgłoszenie jest gotowe do wysłania.',
      success_body: 'Twoja aplikacja e-mail otworzy się teraz z wypełnionym zgłoszeniem. Sprawdź je i, jeśli wybrałeś/aś zdjęcia, załącz je ręcznie przed wysłaniem — automatyczne załączanie nie jest obsługiwane.'
    },
    pt: {
      lang_label: 'Idioma',
      step1_title: 'Em que podemos ajudar?',
      type_cancel: 'Cancelar pedido',
      type_return: 'Devolver artigo',
      type_damaged: 'Danificado / Defeituoso',
      type_delivery: 'Problema de entrega',
      type_other: 'Outro',
      btn_next: 'Seguinte',
      btn_back: 'Voltar',
      btn_submit: 'Enviar pedido',
      btn_start_over: 'Recomeçar',
      yes: 'Sim',
      no: 'Não',
      q_cancel_dispatched: 'O seu pedido já foi expedido?',
      msg_cancel_no: 'O seu cancelamento será processado e o reembolso emitido para o seu método de pagamento original no prazo de 14 dias.',
      msg_cancel_yes: 'O seu pedido já está em trânsito. Pode recusar a entrega (os custos de devolução serão deduzidos do seu reembolso) ou aceitar a entrega e devolver a encomenda fechada no prazo de 14 dias, por sua conta. A encomenda não pode ser aberta nem alterada.',
      ack_cancel_yes: 'Compreendo e aceito estes termos',
      q_return_date: 'Quando recebeu o artigo?',
      msg_return_expired: 'Lamentamos, mas não podemos processar esta devolução. O prazo de devolução de 14 dias já terminou e não podemos aceitar devoluções após este período.',
      q_return_worn: 'O artigo foi usado ou utilizado?',
      msg_return_worn: 'Não podemos aceitar devoluções de artigos usados. Todos os artigos devolvidos devem estar não utilizados, com as etiquetas originais.',
      q_return_packaging: 'A embalagem original está intacta?',
      msg_return_packaging: 'Lamentamos, mas não podemos processar esta devolução. Os artigos devem ser devolvidos na embalagem original, e não podemos aceitar esta devolução sem ela.',
      q_return_hygiene: 'Trata-se de um produto selado por motivos de higiene que foi aberto?',
      msg_return_hygiene: 'Não podemos aceitar devoluções de produtos selados por motivos de higiene depois de abertos.',
      msg_return_approved: 'A sua devolução foi aprovada. Envie-nos o artigo através de um serviço com seguimento, por sua conta. O seu reembolso será emitido no prazo de 14 dias após recebermos e inspecionarmos o artigo. Apenas os custos de envio padrão são reembolsados, não os custos de envio premium.',
      q_return_intl: 'Reside fora do Reino Unido?',
      msg_return_intl_note: 'Será deduzida uma taxa fixa de processamento do seu reembolso para devoluções internacionais.',
      q_delivery_what: 'O que aconteceu?',
      delivery_not_arrived: 'Pedido não chegou',
      delivery_wrong_item: 'Artigo errado recebido',
      delivery_partial: 'Entrega parcial',
      msg_delivery_not_arrived: 'Se o seu pedido não chegou dentro do prazo de entrega estimado, indique os seus dados abaixo para que possamos investigar. Tenha em atenção que os prazos de entrega são estimativas — podem ocorrer atrasos devido a fatores imprevistos.',
      msg_delivery_wrong_item: 'Lamentamos que tenha recebido o artigo errado. Indique abaixo os detalhes do seu pedido, incluindo o artigo recebido e o artigo encomendado. Organizaremos uma solução o mais rapidamente possível.',
      msg_delivery_partial: 'Se o seu pedido chegou incompleto, indique os seus dados abaixo, incluindo os artigos em falta. Iremos analisar a situação e entraremos em contacto consigo.',
      final_title: 'Os seus dados',
      final_order_number: 'Número de encomenda',
      final_full_name: 'Nome completo',
      final_email: 'Endereço de email',
      final_address: 'Morada de entrega',
      final_items: 'Artigo(s) afetado(s)',
      final_description: 'Descrição do pedido',
      final_description_hint: '(mínimo 20 caracteres)',
      final_photo: 'Carregamento de foto',
      required_suffix: '(obrigatório)',
      optional_suffix: '(opcional)',
      err_required: 'Preencha todos os campos obrigatórios.',
      err_email: 'Introduza um endereço de email válido.',
      err_min_chars: 'Introduza pelo menos 20 caracteres na descrição.',
      err_photo_required: 'Anexe pelo menos uma foto para este tipo de pedido.',
      success_title: 'O seu pedido está pronto a ser enviado.',
      success_body: 'A sua aplicação de email irá agora abrir com o pedido pré-preenchido. Reveja-o e, se selecionou fotos, anexe-as manualmente antes de enviar — o anexo automático não é suportado.'
    }
  };

  var TYPE_LABELS_EN = {
    cancel: 'Cancel Order',
    return: 'Return Item',
    damaged: 'Damaged/Defective',
    delivery: 'Delivery Issue',
    other: 'Other'
  };

  var LANGUAGE_NAMES_EN = {
    en: 'English', fr: 'French', de: 'German', it: 'Italian', es: 'Spanish', pl: 'Polish', pt: 'Portuguese'
  };

  function t(lang, key) {
    var dict = STRINGS[lang] || STRINGS.en;
    if (dict[key] !== undefined) return dict[key];
    return STRINGS.en[key] || '';
  }

  function daysBetween(fromDate, toDate) {
    var a = Date.UTC(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
    var b = Date.UTC(toDate.getFullYear(), toDate.getMonth(), toDate.getDate());
    return Math.round((b - a) / 86400000);
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function initInstance(root) {
    var destinationEmail = root.getAttribute('data-destination-email') || 'info@crvdae.com';
    var form = root.querySelector('[data-oe="form"]');
    var langSelect = root.querySelector('[data-oe="lang-select"]');
    var pillsWrap = root.querySelector('[data-oe="pills"]');
    var screenEl = root.querySelector('[data-oe="screen"]');
    var stopMessageEl = root.querySelector('[data-oe="stop-message"]');
    var restartBtn = root.querySelector('[data-oe="restart"]');
    var navEl = root.querySelector('[data-oe="nav"]');
    var backBtn = root.querySelector('[data-oe="back"]');
    var nextBtn = root.querySelector('[data-oe="next"]');
    var submitBtn = root.querySelector('[data-oe="submit"]');
    var errorEl = root.querySelector('[data-oe="error"]');
    var successEl = root.querySelector('[data-oe="success"]');
    var photoSuffixEl = root.querySelector('[data-oe="photo-suffix"]');
    var photoInput = root.querySelector('[data-oe="photo"]');

    if (!form) return;

    var stopped = false;

    var state = {
      lang: 'en',
      branch: null,
      answers: {},
      screenQueue: [],
      screenPos: 0,
      position: 'step1',
      stopKey: null
    };

    function getSelectedType() {
      var checked = pillsWrap.querySelector('input[name="oe_enquiry_type"]:checked');
      return checked ? checked.value : null;
    }

    function updatePhotoSuffix() {
      if (!photoSuffixEl) return;
      photoSuffixEl.textContent = state.branch === 'damaged' ? t(state.lang, 'required_suffix') : t(state.lang, 'optional_suffix');
      photoInput.required = state.branch === 'damaged';
    }

    function applyStaticTranslations() {
      var nodes = root.querySelectorAll('[data-i18n]');
      for (var i = 0; i < nodes.length; i++) {
        var key = nodes[i].getAttribute('data-i18n');
        nodes[i].textContent = t(state.lang, key);
      }
      updatePhotoSuffix();
      if (state.position === 'step2') renderScreen();
      if (state.position === 'stop') renderStopMessage();
    }

    function showPosition(pos) {
      state.position = pos;
      var steps = root.querySelectorAll('[data-oe-step]');
      for (var i = 0; i < steps.length; i++) {
        var key = steps[i].getAttribute('data-oe-step');
        var match = (key === '1' && pos === 'step1') ||
          (key === '2' && pos === 'step2') ||
          (key === 'stop' && pos === 'stop') ||
          (key === '3' && pos === 'step3');
        steps[i].hidden = !match;
      }
      successEl.hidden = true;
      errorEl.hidden = true;

      navEl.hidden = (pos === 'stop');
      backBtn.hidden = (pos === 'step1' || pos === 'stop');
      nextBtn.hidden = (pos === 'step3' || pos === 'stop');
      submitBtn.hidden = (pos !== 'step3');

      if (pos === 'step1') {
        nextBtn.disabled = !getSelectedType();
      }
      if (pos === 'step3') {
        updatePhotoSuffix();
      }
    }

    pillsWrap.addEventListener('change', function () {
      nextBtn.disabled = !getSelectedType();
    });

    function stopFlow(key) {
      stopped = true;
      state.stopKey = key;
    }

    function buildFlow(type) {
      var flow = [];
      switch (type) {
        case 'cancel':
          flow.push({
            id: 'cancel_dispatched', kind: 'yesno', qKey: 'q_cancel_dispatched', onAnswer: function (ans) {
              state.answers.cancel_dispatched = ans;
              if (ans === 'no') {
                flow.push({ id: 'cancel_no_msg', kind: 'message', msgKey: 'msg_cancel_no' });
              } else {
                flow.push({ id: 'cancel_yes_msg', kind: 'message_ack', msgKey: 'msg_cancel_yes', ackKey: 'ack_cancel_yes' });
              }
            }
          });
          break;
        case 'return':
          flow.push({
            id: 'return_date', kind: 'date', qKey: 'q_return_date', onAnswer: function (val) {
              state.answers.return_date = val;
              if (!val) return;
              var received = new Date(val + 'T00:00:00');
              var diff = daysBetween(received, new Date());
              if (diff > 14) stopFlow('msg_return_expired');
            }
          });
          flow.push({
            id: 'return_worn', kind: 'yesno', qKey: 'q_return_worn', onAnswer: function (ans) {
              state.answers.return_worn = ans;
              if (ans === 'yes') stopFlow('msg_return_worn');
            }
          });
          flow.push({
            id: 'return_packaging', kind: 'yesno', qKey: 'q_return_packaging', onAnswer: function (ans) {
              state.answers.return_packaging = ans;
              if (ans === 'no') stopFlow('msg_return_packaging');
            }
          });
          flow.push({
            id: 'return_hygiene', kind: 'yesno', qKey: 'q_return_hygiene', onAnswer: function (ans) {
              state.answers.return_hygiene = ans;
              if (ans === 'yes') stopFlow('msg_return_hygiene');
            }
          });
          flow.push({ id: 'return_approved', kind: 'message', msgKey: 'msg_return_approved' });
          flow.push({
            id: 'return_intl', kind: 'yesno', qKey: 'q_return_intl', onAnswer: function (ans) {
              state.answers.return_intl = ans;
              if (ans === 'yes') {
                flow.push({ id: 'return_intl_note', kind: 'message', msgKey: 'msg_return_intl_note' });
              }
            }
          });
          break;
        case 'delivery':
          flow.push({
            id: 'delivery_what', kind: 'radio', qKey: 'q_delivery_what', options: ['not_arrived', 'wrong_item', 'partial'], onAnswer: function (val) {
              state.answers.delivery_what = val;
            }
          });
          flow.push({
            id: 'delivery_note', kind: 'message', resolveMsgKey: function () {
              var map = { not_arrived: 'msg_delivery_not_arrived', wrong_item: 'msg_delivery_wrong_item', partial: 'msg_delivery_partial' };
              return map[state.answers.delivery_what];
            }
          });
          break;
        case 'damaged':
        case 'other':
        default:
          break;
      }
      return flow;
    }

    function renderStopMessage() {
      stopMessageEl.textContent = t(state.lang, state.stopKey);
    }

    function goToStop() {
      renderStopMessage();
      showPosition('stop');
    }

    function goToFinal() {
      showPosition('step3');
    }

    function renderScreen() {
      var scr = state.screenQueue[state.screenPos];
      if (!scr) { goToFinal(); return; }
      screenEl.innerHTML = '';
      nextBtn.hidden = false;

      if (scr.kind === 'message' || scr.kind === 'message_ack') {
        var msg = document.createElement('div');
        msg.className = 'oe-message';
        msg.textContent = t(state.lang, scr.resolveMsgKey ? scr.resolveMsgKey() : scr.msgKey);
        screenEl.appendChild(msg);

        if (scr.kind === 'message_ack') {
          var ackWrap = document.createElement('label');
          ackWrap.className = 'oe-ack';
          var ackInput = document.createElement('input');
          ackInput.type = 'checkbox';
          ackInput.checked = !!scr.ackChecked;
          ackInput.addEventListener('change', function () {
            scr.ackChecked = ackInput.checked;
            nextBtn.disabled = !ackInput.checked;
          });
          var ackText = document.createElement('span');
          ackText.textContent = t(state.lang, scr.ackKey);
          ackWrap.appendChild(ackInput);
          ackWrap.appendChild(ackText);
          screenEl.appendChild(ackWrap);
          nextBtn.disabled = !scr.ackChecked;
        } else {
          nextBtn.disabled = false;
        }
        return;
      }

      if (scr.kind === 'yesno') {
        var qWrap = document.createElement('div');
        qWrap.className = 'oe-question';
        var qText = document.createElement('label');
        qText.className = 'oe-question__label';
        qText.textContent = t(state.lang, scr.qKey);
        qWrap.appendChild(qText);

        var yesNoWrap = document.createElement('div');
        yesNoWrap.className = 'oe-yesno';

        ['yes', 'no'].forEach(function (val) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.textContent = t(state.lang, val);
          if (scr.selected === val) btn.classList.add('is-selected');
          btn.addEventListener('click', function () {
            scr.selected = val;
            var buttons = yesNoWrap.querySelectorAll('button');
            for (var i = 0; i < buttons.length; i++) buttons[i].classList.remove('is-selected');
            btn.classList.add('is-selected');
            nextBtn.disabled = false;
          });
          yesNoWrap.appendChild(btn);
        });

        qWrap.appendChild(yesNoWrap);
        screenEl.appendChild(qWrap);
        nextBtn.disabled = !scr.selected;
        return;
      }

      if (scr.kind === 'date') {
        var dWrap = document.createElement('div');
        dWrap.className = 'oe-field';
        var dText = document.createElement('label');
        dText.textContent = t(state.lang, scr.qKey);
        var dInput = document.createElement('input');
        dInput.type = 'date';
        dInput.max = new Date().toISOString().slice(0, 10);
        dInput.value = scr.selected || '';
        dInput.addEventListener('change', function () {
          scr.selected = dInput.value;
          nextBtn.disabled = !dInput.value;
        });
        dWrap.appendChild(dText);
        dWrap.appendChild(dInput);
        screenEl.appendChild(dWrap);
        nextBtn.disabled = !scr.selected;
        return;
      }

      if (scr.kind === 'radio') {
        var rWrap = document.createElement('div');
        rWrap.className = 'oe-question';
        var rText = document.createElement('label');
        rText.className = 'oe-question__label';
        rText.textContent = t(state.lang, scr.qKey);
        rWrap.appendChild(rText);

        var pillsRow = document.createElement('div');
        pillsRow.className = 'oe-pills';
        scr.options.forEach(function (opt) {
          var pillLabel = document.createElement('label');
          pillLabel.className = 'oe-pill';
          var input = document.createElement('input');
          input.type = 'radio';
          input.name = 'oe_dyn_' + scr.id;
          input.value = opt;
          if (scr.selected === opt) input.checked = true;
          input.addEventListener('change', function () {
            scr.selected = opt;
            nextBtn.disabled = false;
          });
          var span = document.createElement('span');
          span.textContent = t(state.lang, 'delivery_' + opt);
          pillLabel.appendChild(input);
          pillLabel.appendChild(span);
          pillsRow.appendChild(pillLabel);
        });
        rWrap.appendChild(pillsRow);
        screenEl.appendChild(rWrap);
        nextBtn.disabled = !scr.selected;
        return;
      }
    }

    nextBtn.addEventListener('click', function () {
      if (state.position === 'step1') {
        state.branch = getSelectedType();
        if (!state.branch) return;
        state.answers = {};
        state.screenQueue = buildFlow(state.branch);
        state.screenPos = 0;
        stopped = false;
        if (state.screenQueue.length === 0) {
          goToFinal();
        } else {
          showPosition('step2');
          renderScreen();
        }
        return;
      }

      if (state.position === 'step2') {
        var scr = state.screenQueue[state.screenPos];
        var answerValue = (scr.kind === 'message' || scr.kind === 'message_ack') ? null : scr.selected;
        if (scr.onAnswer) scr.onAnswer(answerValue);
        if (stopped) {
          goToStop();
          return;
        }
        state.screenPos++;
        if (state.screenPos >= state.screenQueue.length) {
          goToFinal();
        } else {
          renderScreen();
        }
      }
    });

    backBtn.addEventListener('click', function () {
      if (state.position === 'step2') {
        if (state.screenPos === 0) {
          showPosition('step1');
        } else {
          state.screenPos--;
          renderScreen();
        }
        return;
      }
      if (state.position === 'step3') {
        if (state.screenQueue.length === 0) {
          showPosition('step1');
        } else {
          state.screenPos = state.screenQueue.length - 1;
          showPosition('step2');
          renderScreen();
        }
      }
    });

    restartBtn.addEventListener('click', function () {
      stopped = false;
      state.branch = null;
      state.answers = {};
      state.screenQueue = [];
      state.screenPos = 0;
      var radios = pillsWrap.querySelectorAll('input[name="oe_enquiry_type"]');
      for (var i = 0; i < radios.length; i++) radios[i].checked = false;
      showPosition('step1');
    });

    langSelect.addEventListener('change', function () {
      state.lang = langSelect.value;
      applyStaticTranslations();
    });

    function showError(msg) {
      errorEl.textContent = msg;
      errorEl.hidden = false;
    }

    function buildBranchSummary() {
      switch (state.branch) {
        case 'cancel':
          return state.answers.cancel_dispatched === 'no'
            ? 'Customer confirmed order has not yet been dispatched — cancellation to be processed, refund within 14 days.'
            : 'Customer confirmed order already shipped — accepted return terms (refuse delivery with return cost deducted, or accept and return unopened within 14 days at own cost).';
        case 'return':
          var summary = 'Return approved — received within 14 days, item unused with tags attached, packaging intact, not an opened hygiene-sealed product.';
          if (state.answers.return_intl === 'yes') {
            summary += ' International return — flat processing fee applies.';
          }
          return summary;
        case 'damaged':
          return 'Damaged/Defective item reported — photo evidence attached.';
        case 'delivery':
          var map = { not_arrived: 'Order not arrived', wrong_item: 'Wrong item received', partial: 'Partial delivery' };
          return 'Delivery issue reported — ' + (map[state.answers.delivery_what] || 'Unspecified') + '.';
        case 'other':
          return 'General enquiry — no specific branch conditions apply.';
        default:
          return '';
      }
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (state.position !== 'step3') return;

      var orderNumber = root.querySelector('[data-oe="order-number"]').value.trim();
      var name = root.querySelector('[data-oe="name"]').value.trim();
      var email = root.querySelector('[data-oe="email"]').value.trim();
      var address = root.querySelector('[data-oe="address"]').value.trim();
      var items = root.querySelector('[data-oe="items"]').value.trim();
      var description = root.querySelector('[data-oe="description"]').value.trim();

      if (!orderNumber || !name || !email || !address || !items || !description) {
        showError(t(state.lang, 'err_required'));
        return;
      }
      if (!isValidEmail(email)) {
        showError(t(state.lang, 'err_email'));
        return;
      }
      if (description.length < 20) {
        showError(t(state.lang, 'err_min_chars'));
        return;
      }
      if (state.branch === 'damaged' && (!photoInput.files || photoInput.files.length === 0)) {
        showError(t(state.lang, 'err_photo_required'));
        return;
      }

      errorEl.hidden = true;

      var typeLabel = TYPE_LABELS_EN[state.branch] || 'Other';
      var subject = 'Order Enquiry — ' + typeLabel + ' — #' + orderNumber;

      var lines = [];
      lines.push('Enquiry type: ' + typeLabel);
      lines.push('Order number: ' + orderNumber);
      lines.push('Customer name: ' + name);
      lines.push('Customer email: ' + email);
      lines.push('Delivery address: ' + address);
      lines.push('Item(s): ' + items);
      lines.push('Description: ' + description);
      lines.push('Branch-specific info: ' + buildBranchSummary());

      if (photoInput.files && photoInput.files.length > 0) {
        var names = [];
        for (var i = 0; i < photoInput.files.length; i++) names.push(photoInput.files[i].name);
        lines.push('Photos attached: ' + photoInput.files.length + ' file(s) selected (' + names.join(', ') + ') — please attach these manually, automatic attachment is not supported by this form.');
      }

      if (state.lang !== 'en') {
        lines.push('');
        lines.push('Original language: ' + (LANGUAGE_NAMES_EN[state.lang] || state.lang) + '. Below is the customer’s message, which may need translation.');
      }

      var body = lines.join('\n');
      var mailto = 'mailto:' + encodeURIComponent(destinationEmail) +
        '?subject=' + encodeURIComponent(subject) +
        '&body=' + encodeURIComponent(body);

      successEl.hidden = false;
      window.location.href = mailto;
    });

    langSelect.value = 'en';
    showPosition('step1');
    applyStaticTranslations();
  }

  function init() {
    var roots = document.querySelectorAll('[data-oe-root]');
    for (var i = 0; i < roots.length; i++) initInstance(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
